import * as M from '@materializecss/materialize'

window.M = M
